module.exports = __webpack_public_path__ + "static/certificate4-7a6e511e627f01e680ab1f34143d3c73.jpg";